import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import DeliveryNotificationSelector from './delivery-notification-selector';
import messages from './messages';
import PackingSlipSelector from './packing-slip-selector';
import ShipmentNotificationSelector from './shipment-notification-selector';
import Global from '../../../../../store/global-selectors';
import { useBTEmailExperienceNew } from '../../../../../hooks/use-seller-setting';

import style from './order-templates.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const OrderTemplates = ({
  className,
  labelClassName,
  valueClassName,
  fulfillmentPlanId,
  packingSlips = emptyArray,
  shipmentTemplates = emptyArray,
  deliveryTemplates = emptyArray,
  selectedPackingSlip,
  selectedShipmentTemplate,
  selectedDeliveryTemplate,
  onPackingSlipSelected,
  onShipmentNotificationSelected,
  onDeliveryNotificationSelected,
}) => {
  const sellerBrandId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'sellerBrandId',
    }),
  );
  const { companyName: sellerBrandName } = useSelector((state) => Global.selectSellerSellerBrandById(state, { sellerBrandId })) || {
    companyName: <FormattedMessage {...messages.noBrandText} />,
  };
  const enableNewEmailExperience = useBTEmailExperienceNew();
  const showNotificationTemplates = !enableNewEmailExperience;

  return (
    <div className={classnames(style.container, className)}>
      <div className={classnames(style['select-container'], 'select-container')}>
        <div className={classnames(style['select-label'], 'brand-label', labelClassName)}>
          <FormattedMessage {...messages.brandLabel} />
        </div>
        <div className={valueClassName}>{sellerBrandName}</div>
      </div>
      <PackingSlipSelector onPackingSlipSelected={onPackingSlipSelected} packingSlips={packingSlips} selected={selectedPackingSlip} />
      {showNotificationTemplates && (
        <>
          <ShipmentNotificationSelector
            onShipmentNotificationSelected={onShipmentNotificationSelected}
            selected={selectedShipmentTemplate}
            shipmentTemplates={shipmentTemplates}
          />
          <DeliveryNotificationSelector
            deliveryTemplates={deliveryTemplates}
            onDeliveryNotificationSelected={onDeliveryNotificationSelected}
            selected={selectedDeliveryTemplate}
          />
        </>
      )}
    </div>
  );
};

OrderTemplates.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  fulfillmentPlanId: PropTypes.string.isRequired,
  onPackingSlipSelected: PropTypes.func.isRequired,
  onShipmentNotificationSelected: PropTypes.func.isRequired,
  onDeliveryNotificationSelected: PropTypes.func.isRequired,
  packingSlips: PropTypes.array,
  shipmentTemplates: PropTypes.array,
  deliveryTemplates: PropTypes.array,
  selectedPackingSlip: PropTypes.object,
  selectedShipmentTemplate: PropTypes.object,
  selectedDeliveryTemplate: PropTypes.object,
};

export default OrderTemplates;
